var customerSubTypes = [
  { "name": "Ministry", "label": "وزارتخانه", value: 0 },
  { "name": "GovernmentInstitute", "label": "موسسه دولتی", value: 1 },
  { "name": "GovernmentCompany", "label": "شرکت دولتی", value: 2 },
  { "name": "OtherGovernmentAgencies", "label": "سایر دستگاه های دولتی", value: 3 },
  { "name": "NonGovernmentalPublicInstitutions", "label": "نهاهای عمومی غیر دولتی", value: 4 },
  { "name": "PrivateSector", "label": "بخش خصوصی", value: 5 },
  { "name": "Other", "label": "سایر", value: 6 },
];

export default customerSubTypes;